module.exports = __webpack_public_path__ + "static/media/lecy-magagnini.0715a686.png";